import { Checkout } from "ui/components/3-organisms/Checkout";



export const CheckoutFeature: React.VFC<Umbraco.checkout> = ({ content }) => {
	return <Checkout {...content.properties} />;
};